import { useContext, useEffect, useState } from "react";
import { MultiContext } from "../../Context";
import Button from "../atoms/Button";
import markdownit from "markdown-it";

export default function Readme({ className = "" }) {
  const multiCtx = useContext(MultiContext);
  const [content, setContent] = useState("");
  const [, setSaved] = useState(false);

  const onChangeContent = (e) => setContent(e.target.value);

  useEffect(() => {
    setContent(multiCtx.currentRepo?.readme || "");
  }, [multiCtx.currentRepo]);

  return (
    <div className={className}>
      <div className="flex">
        <div className="col-50">
          <div
            className={
              multiCtx.currentRepo?.readme !== content ? "" : "invisible"
            }>
            <Button
              text="Save Changes"
              onClick={() => {
                multiCtx.editReadme(content);
                setSaved(true);
                setTimeout(() => setSaved(false), 1500);
              }}
              className="orange mb-1"
              icon="record2-fill"
            />
          </div>
          <textarea
            id="editor"
            onMouseUp={() => getSelection()}
            rows={25}
            onChange={onChangeContent}
            value={content}
            className="form-control "></textarea>
        </div>
        <div className="divider"></div>
        <div
          className="col-50"
          id="readme"
          dangerouslySetInnerHTML={{
            __html: markdownit({ html: true }).render(content),
          }}></div>
      </div>
    </div>
  );
}
